import { getCsrfValue } from "../../../../api/ApiHelper";

import { resolveApiUrl } from "../../../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/ship/to/address");
export const createAddress = (data: {}): Promise<any> => {
  return fetch(apiUrl, {
    body: JSON.stringify(data),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
};
